import customAxiosInterceptor from "../customAxiosInterceptor";

// Fetch partners
// GET https://api.infocomp.ba/api/post
export const fetchPartnersThunk = async (_, thunkAPI) => {
  try {
    const response = await customAxiosInterceptor.get("/post", {
      params: {
        page: 1,
        take: 12,
        order: "ASC",
        post_type: "partneri",
      },
    });
    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response.data.msg);
  }
};

// Fetch partner with slug
// GET https://api.infocomp.ba/api/post/1
export const fetchPartnerBySlugThunk = async (post_slug, thunkAPI) => {
  try {
    const response = await customAxiosInterceptor.get(`/post/${post_slug}`);
    return response.data.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response.data.msg);
  }
};
